import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query'
import { App as AntdApp } from 'antd'
import { BrowserRouter } from 'react-router-dom'

import { OpenAPI } from './api/requests'
import AntdMessages from './components/AntdMessages/AntdMessages'
import { SessionContextProvider, UserProvider } from './contexts'
import { Router } from './Router'
import { ThemeProviderWrapper } from './theme'

import 'antd/dist/reset.css'

const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache(),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: false
    }
  }
})

OpenAPI.BASE = import.meta.env.VITE_BASE_URL

export const App = () => {
  return (
    <ThemeProviderWrapper>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AntdApp>
            <AntdMessages />
            <SessionContextProvider>
              <UserProvider>
                <Router />
              </UserProvider>
            </SessionContextProvider>
          </AntdApp>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProviderWrapper>
  )
}
